export default {
    ca: {
        title: 'Estem preparant un nou taller d\'InstaMaps. T\'interessa?',
        message: 'Si vols més informació, deixa\'ns aquí el teu email',
        emailValidation: 'L\'email és obligatori i ha de ser vàlid',
        privacyPoliciesMsg: 'Enviant el teu email acceptes',
        privacyPoliciesLink: 'la política de privacitat',
        submitSuccessMsg: 'El teu email s\'ha enviat correctament',
        submitErrorMsg: 'S\'ha produit un error enviant el teu email',
    },
    es: {
        title: 'Estamos preparando un nuevo taller de InstaMaps. ¿Te interesa?',
        message: 'Si quieres más información, déjanos aquí tu email',
        emailValidation: 'El email es obligatorio y debe ser válido',
        privacyPoliciesMsg: 'Enviando tu email aceptas',
        privacyPoliciesLink: 'la política de privacidad',
        submitSuccessMsg: 'Tu email se ha enviado correctamente',
        submitErrorMsg: 'Ha habido uin error al enviar tu email',
    },
    en: {
        title: 'We are preparing a new InstaMaps workshop. Are you interested?',
        message: 'If you want more information, please give us your email',
        emailValidation: 'The email is a required field and must be valid',
        privacyPoliciesMsg: 'By sending your email you are accepting the',
        privacyPoliciesLink: 'privacy policies',
        submitSuccessMsg: 'Your email has been sent succesfully',
        submitErrorMsg: 'An error occurred while sending your email',
    },
};



// WEBPACK FOOTER //
// ./src/home-geolocal/components/newsletter-modal/newsletter-modal-translations.js